const typographyPendente = {
  name: 'Hello, Guilherme Neves Herker',
  access: 'Your access has not yet been granted',
  email: 'You will receive an email once your access is approved by your system administrator',
  doubt: 'doubts? Get in touch with',
  doubt1: 'ilton@adm.com'
};

export default typographyPendente;
